module.exports = __webpack_public_path__ + "img/06.58c39228.gif";